
let gConfig = {
    web_pc: '/web_pc'
}
export default gConfig;



// WEBPACK FOOTER //
// ./src/gConfig.js